import { Modal, Alert, Icon } from '@chikara/ui';
import { MfaVerify } from './MfaVerify';
import styles from './MfaModal.module.css';

interface MfaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onVerify: (otp: string) => Promise<void> | void;
  isLoading?: boolean;
  error?: string;
}

export function MfaModal({ isOpen, onClose, onVerify, isLoading, error }: MfaModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      showCloseButton={true}
      isActionLoading={isLoading}
      contentSize="sm"
    >
      <div className={styles.container}>
        <MfaVerify onVerify={onVerify} isLoading={isLoading} />
        {error && (
          <Alert variant="error" icon={<Icon name="error" color="inherit" />} className={styles.alert}>
            {error}
          </Alert>
        )}
      </div>
    </Modal>
  );
}
